import DeleteIcon from '@mui/icons-material/Delete';
import { removeLocale } from '../../../actions';
import iconButtonCellFactory from './icon-button-cell';

export default iconButtonCellFactory({
  getButtonProps() {
    return {
      children: <DeleteIcon />
    };
  },
  getAction(props) {
    return removeLocale({ locale: props.row.code });
  }
});
